import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FeatureFlagService } from "../../services/feature-flag/feature-flag.service";

@Component({
  selector: 'app-relatorio-apresentacao',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './relatorio-apresentacao.component.html',
  styleUrl: './relatorio-apresentacao.component.scss'
})
export class RelatorioApresentacaoComponent {
  constructor(public featureFlagService: FeatureFlagService) {
  }
  @Input() breadcrumb: string = '';
  @Input() breadcrumbColor: string = '';

  @Input() iconeHero: string = '';
  @Input() corIconeHero: string = '';
  @Input() tituloHero: string = '';
  @Input() corTituloHero: string = '';
  @Input() subtituloHero: string = '';
  @Input() corSubtituloHero: string = '';
  @Input() descricaoHero: string = '';
  @Input() textoBotaoHero: string = '';
  @Input() corBotaoHero: string = '';
  @Input() corTextoBotaoHero: string = '';
  @Input() linkBotaoHero: string = '';
  @Input() imagemHero: string = '';
  @Input() backgroundHero: string = '';

  @Input() infoIcone: Array<{ img: string, text: string, color: string }> = [];
  @Input() infoTexto: Array<{ html: string, color: string }> = [];

  @Input() tituloCta: string = '';
  @Input() textoBotaoCta: string = '';
  @Input() corBotaoCta: string = '';
  @Input() corTextoBotaoCta: string = '';
  @Input() linkBotaoCta: string = '';

  @Input() corSetaHero: string = '';
  @Input() corSetaCta: string = '';

  prevSlide() {}
  nextSlide() {}
}
